// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topbar {
  height: 60px;
  background: #000;
  position: sticky;
  top: 0;
  z-index: 1040;

  /* no margin-left here */
  width: 100%;
  flex-shrink: 0;
}


.topbar-inner {
  width: 100%;
  padding: 0 1rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.navbar {
  display: flex;
  padding: 0 !important;
  margin: 0 !important;
}

.logout-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #d9534f;
  color: #fff;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s ease;
  margin-right: 20px;
}

.logout-btn:hover {
  background-color: #c9302c;
}

.logout-btn span {
  font-size: 14px;
}


@media (max-width: 768px) {
  .topbar {
    margin-left: 0;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Header/Header.css"],"names":[],"mappings":"AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,aAAa;;EAEb,wBAAwB;EACxB,WAAW;EACX,cAAc;AAChB;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE;IACE,cAAc;IACd,WAAW;EACb;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');\n\n.topbar {\n  height: 60px;\n  background: #000;\n  position: sticky;\n  top: 0;\n  z-index: 1040;\n\n  /* no margin-left here */\n  width: 100%;\n  flex-shrink: 0;\n}\n\n\n.topbar-inner {\n  width: 100%;\n  padding: 0 1rem;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.navbar {\n  display: flex;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.logout-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #d9534f;\n  color: #fff;\n  border: none;\n  padding: 8px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.3s ease;\n  margin-right: 20px;\n}\n\n.logout-btn:hover {\n  background-color: #c9302c;\n}\n\n.logout-btn span {\n  font-size: 14px;\n}\n\n\n@media (max-width: 768px) {\n  .topbar {\n    margin-left: 0;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
